export enum TransactionType {
    None = 0,
    ACH,
    Wire,
    Card,
    Internal,
    ATM,
    Fee,
    Interest,
    Online,
    InStore,
    Other,
    Check
}

export namespace TransactionType {
    export function toString(type: TransactionType): string {
        switch (type) {
            case TransactionType.ACH:
                return 'ACH';
              case TransactionType.Wire:
                return 'Wire';
              case TransactionType.Card:
                return 'Card';
              case TransactionType.Internal:
                return 'Internal';
              case TransactionType.ATM:
                return 'ATM';
              case TransactionType.Fee:
                return 'Fee';
              case TransactionType.Interest:
                return 'Interest';
                case TransactionType.Online:
                return 'Online';
                case TransactionType.InStore:
                return 'InStore';
                case TransactionType.Other:
                return 'Other';
                case TransactionType.Check:
                return 'Check';
              default:
                return '';
        }
      }
    
      export function parse(transactionTypeStr: string): TransactionType {
        return TransactionType[transactionTypeStr];
      }

      export function getIcon(type: TransactionType): string {
        switch (type) {
          case TransactionType.ACH:
            return 'arrow_circle_right';
          case TransactionType.Wire:
            return 'send';
          case TransactionType.Card:
            return 'credit_card';
          default:
            return '';
        }
      }
}

export default TransactionType;